<template>
<div>
    <div
          id="searchMyPostion"
          class="cusLayer on orderHistoryDetail full"
      >
      <Loading v-if="getLoading" />
      <div class="cusHd" >
          <div class="in justify-content-center">
              <h1 class="tit">내 위치 확인</h1>
              <button @click="onClickCloseBtn()" class="btnCloseModal">닫기</button>
          </div>
          <div class="map-container" v-if="getUseKaKaoMap">
            <KakaoMap style="height: 400px; margin-top: 10px"
            :isMyLocation = true
            />
            <div class="map-notice">
              <p>지도의 표시와 실제 주소가 맞는지 확인해주세요.</p>
            </div>
          </div>
          <div class="bottom-fixed">
              <p class="main-location">{{ getAddress }}</p>
              <div class="d-flex">
                  <span class="tag">도로명</span>
                  <p class="roadname">{{ getRoadAddress }}</p>
              </div>
              <button @click.stop="setMapAndClose()">배달주소로 주소 등록</button>
          </div>
      </div>
    </div>
</div>
</template>

<script lang="js">
import $ from 'jquery'
import Loading from '@/components/Common/Loading.vue'
import KakaoMap from '@/components/Map/KakaoMap.vue'
import { SET_SELECTED_ADDRESS, SET_USE_KAKAO_MAP } from '@/store/_actions/actionTypes'
export default {
  components: { KakaoMap, Loading },
  computed: {
    getAddressKaKaoMap () {
      return this.$store.getters.addressKaKaoMap
    },
    getAddress () {
      const addr = this.$store.getters.addressKaKaoMap?.address
      return addr || '지번 주소가 없습니다.'
    },
    getRoadAddress () {
      const roadAddress = this.$store.getters.addressKaKaoMap?.roadAddress
      return roadAddress || '도로명 주소가 없습니다.'
    },
    getUseKaKaoMap () {
      return this.$store.getters.useKaKaoMap
    },
    getLoading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    onClickCloseBtn () {
      this.removeDim()
      this.$store.commit(SET_USE_KAKAO_MAP, false)
      $('#searchMyPostion.cusLayer').animate({ bottom: '-100%' }, 400)
    },
    setMapAndClose () {
      console.log('## setMapAndClose')
      this.onClickCloseBtn()
      this.$store.commit(SET_SELECTED_ADDRESS, this.getAddressKaKaoMap)
    }
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  position: relative;
  width: 100%;
  left: 0;
}
.bottom-fixed {
  display: block;
  margin: auto -16px 0;
  bottom: 0;
  padding: 2.4rem 1.6rem;
  box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.1);
  width: auto;
  left: 0;
  height: 17.3rem;
  background-color: #ffffff;

  button {
    padding: 1.6rem 9.4rem;
    background-color: var(--primary);
    margin-top: 1.6rem;
    color: #ffffff;
    font-size: 1.6rem;
    font-weight: normal;
    width: 100%;
  }
}
.main-location {
  font-size: 2.2rem;
  font-weight: bold;
  line-height: 1.4;
  color: #0d0d0d;
  text-align: left;
  margin-bottom: 1rem;
}
.roadname {
  font-size: 1.6rem;
  color: #0d0d0d;
  opacity: 0.6;
}
.btn-search {
  padding: 1rem 0;
  cursor: pointer;
  width: 100%;
  border: 1px solid var(--primary);
  color: var(--primary);
  font-weight: bold;
  margin-top: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-search span {
  position: relative;
  padding-left: 3rem;
}
.btn-search::before {
  background-image: url("../assets/img/ic-gps.svg");
  content: "";
  position: absolute;
  width: 2.2rem;
  height: 2.2rem;
  background-size: 2.2rem;
  margin-left: -9rem;
}
.justify-content-center {
  justify-content: center;
}
#searchMyPostion.cusLayer.orderHistoryDetail .cusHd {
  height: 100%;
  display: flex;
  flex-flow: column;
}
#searchMyPostion.cusLayer.orderHistoryDetail .cusHd .in {
  display: flex;
  align-items: center;
  padding: 0 0 13px;
  border-bottom: 1px solid #0d0d0d;
}
#searchMyPostion.cusLayer.orderHistoryDetail .cusHd .in .tit {
  margin-right: 8px;
}
#searchMyPostion.cusLayer.orderHistoryDetail .cusCnt {
  padding: 0 16px 21px;
}
#searchMyPostion.cusLayer{
  z-index: 10211;
}
.map-notice {
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  padding: 10px;
  background-color: #fff;
  z-index: 10;
  p {
    color: red;
    text-align: center;
  }
}
</style>
